/* Buy box — scent selection, bundle tiers, and the resulting cart payload.
   Prices and variant ids all come from Liquid; nothing is hardcoded here. */
(function () {
  'use strict';

  /* The attribution integration retries the same attribute-only GET write when
     its remote pixel endpoint fails. Reuse successful identical writes for one
     minute so those retries cannot repeatedly lock the Shopify cart. Changed
     attributes, failures, and every actual cart mutation still reach Shopify. */
  if (/\/products\/body-oil(?:-v[123])?\/?$/.test(window.location.pathname) &&
      window.fetch && !window.__bodyOilAttributionDedupe) {
    window.__bodyOilAttributionDedupe = true;
    var attributionFetch = window.fetch;
    var attributionWrites = Object.create(null);
    window.fetch = function (input, options) {
      var url, method;
      try {
        url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
        method = String((options && options.method) || (input && input.method) || 'GET').toUpperCase();
      } catch (error) { return attributionFetch.apply(this, arguments); }
      var onlyAttributes = true;
      url.searchParams.forEach(function (value, key) {
        if (!/^attributes\[[^\]]+\]$/.test(key)) onlyAttributes = false;
      });
      if (method !== 'GET' || url.origin !== window.location.origin ||
          !/\/cart\/update\.js$/.test(url.pathname) || !onlyAttributes ||
          !url.searchParams.has('attributes[host]') || !url.searchParams.has('attributes[sw]') ||
          !url.searchParams.has('attributes[sh]')) return attributionFetch.apply(this, arguments);
      url.searchParams.sort();
      var key = url.href;
      var now = Date.now();
      Object.keys(attributionWrites).forEach(function (entryKey) {
        var entry = attributionWrites[entryKey];
        if (entry.expires && entry.expires <= now) delete attributionWrites[entryKey];
      });
      var cached = attributionWrites[key];
      if (!cached) {
        cached = { expires: 0, promise: null };
        attributionWrites[key] = cached;
        cached.promise = attributionFetch.apply(this, arguments).then(function (response) {
          if (!response.ok) delete attributionWrites[key];
          else cached.expires = Date.now() + 60000;
          return response;
        }, function (error) {
          delete attributionWrites[key];
          throw error;
        });
      }
      return cached.promise.then(function (response) { return response.clone(); });
    };
  }


  /* Cards are all as tall as the tallest, so a short quote does not give a short
       card. CSS cannot do it: Flickity absolutely positions its cells, and
       height:100% resolves against a viewport height Flickity has not computed yet,
       which collapses the carousel. Heights are cleared before measuring so a re-run
       shrinks as well as grows. */
  function initSocialHeights(root) {
    var carousel = root.querySelector('[data-pdp-social] flickity-carousel');
    if (!carousel) return;

    function equalise() {
      var cards = carousel.querySelectorAll('[data-social-card]');
      if (cards.length < 2) return;
      var i;
      for (i = 0; i < cards.length; i++) cards[i].style.height = '';
      var tallest = 0;
      for (i = 0; i < cards.length; i++) tallest = Math.max(tallest, cards[i].offsetHeight);
      if (!tallest) return;
      for (i = 0; i < cards.length; i++) cards[i].style.height = tallest + 'px';
    }

    // The carousel is lazy — theme.js only initialises it near the viewport.
    carousel.addEventListener('flickity:ready', equalise);
    // Webfonts and avatars change where the quotes wrap.
    window.addEventListener('load', equalise);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(equalise, 150);
    });

    equalise();
  }

  /* The real-results carousel has the same problem as the social cards: Flickity
     positions its cells absolutely, so height:100% collapses them and the cards
     end up ragged. Every quote takes the measured height of the longest instead. */
  function initResultHeights(root) {
    var carousel = root.querySelector('.product-form-28__results-track');
    if (!carousel) return;

    function equalise() {
      var quotes = carousel.querySelectorAll('[data-results-quote]');
      if (quotes.length < 2) return;
      var i;
      for (i = 0; i < quotes.length; i++) quotes[i].style.height = '';
      var tallest = 0;
      for (i = 0; i < quotes.length; i++) tallest = Math.max(tallest, quotes[i].offsetHeight);
      if (!tallest) return;
      for (i = 0; i < quotes.length; i++) quotes[i].style.height = tallest + 'px';
      // the cards just changed height, so let Flickity re-measure
      if (carousel.flickityInstance) {
        Promise.resolve(carousel.flickityInstance).then(function (instance) {
          if (carousel.isConnected && instance) instance.resize();
        });
      }
    }

    carousel.addEventListener('flickity:ready', equalise);
    window.addEventListener('load', equalise);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(equalise, 150);
    });

    equalise();
  }

  function init(root) {
    if (root.dataset.pdpBuyReady === '1') return;
    root.dataset.pdpBuyReady = '1';

    // The JSON payload is emitted at section level, above the buy box column,
    // so fall back to the enclosing section before giving up.
    var scope = root.closest('.shopify-section') || document;
    var dataEl = root.querySelector('[data-pdp-variant-data]') || scope.querySelector('[data-pdp-variant-data]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    function byId(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    // The BOGO free gift may come from a different product. Without its own
    // list, byId would silently return a paid variant instead.
    var freeVariants = variants;
    var freeEl = scope.querySelector('[data-pdp-free-variant-data]');
    if (freeEl) {
      try {
        var parsedFree = JSON.parse(freeEl.textContent);
        if (parsedFree && parsedFree.length) freeVariants = parsedFree;
      } catch (e) {
        /* fall back to the paid list */
      }
    }

    function byFreeId(id) {
      for (var i = 0; i < freeVariants.length; i++) {
        if (String(freeVariants[i].id) === String(id)) return freeVariants[i];
      }
      return freeVariants[0];
    }

    /* The markup decides which tier opens selected, and a variant-backed tier
       names its variant. Hard-coding 'bogo' here left a variant-priced product
       selling variant one while tier two looked chosen. */
    var initialTier = root.querySelector('[data-tier][data-selected="true"]');
    var initialVariant = variants[0];
    if (initialTier && initialTier.dataset.tierVariant) {
      initialVariant = byId(initialTier.dataset.tierVariant) || initialVariant;
    }

    /* A scent card on the home page points at the shared perfume PDP through the
       redirect metafield, so all three used to land on the same page showing
       whichever scent it opens on. The card appends ?scent=<its variant id> and
       the page opens on that one instead.

       Compared against the payload rather than handed to byId directly: byId
       falls back to variants[0] for anything it does not know, so a stale or
       hand-typed id would silently look like a successful match.
     */
    try {
      var scentParam = new URLSearchParams(window.location.search).get('scent');
      if (scentParam) {
        for (var si = 0; si < variants.length; si++) {
          /* Either id the scent answers to. A scent is two products now - the
             one sold outright and the -sub twin the ritual switch swaps to - and
             a card on the collection or home page carries whichever of the two
             it happens to be for. Matching only the paid id meant a card built
             from the twin fell through here and the page opened on the first
             scent, which is what "it always lands on Seduction" was. */
          if (
            String(variants[si].id) === String(scentParam) ||
            (variants[si].subVariantId && String(variants[si].subVariantId) === String(scentParam))
          ) {
            initialVariant = variants[si];
            break;
          }
        }
      }
    } catch (e) {}

    /* Products the section marks as single-unit. On a template with no tiers
       block nothing is ever selected, so the fallback below decides the whole
       cart on its own, and 'bogo' quietly added a second line the customer
       never asked for. Only the handles named in 28-main-product.liquid opt
       out; every other page keeps the fallback it has always had. */
    var singleUnit = root.dataset.singleUnit === 'true';

    /* Whether this template has tier rows at all. 28-product-bundle-tiers emits
       them and labels each one; 28-product-custom_variants_picker does not - its
       cards are radios over the product's variants, so the quantity lives in the
       variant itself and "4 Serum Bottles" IS four.

       That distinction decides the fallback below. 'bogo' means the second unit
       is this same variant, pushed again, and on a variant-backed picker that
       charged for a bottle nobody chose: picking 4 Serum Bottles at 58.50 also
       added the 1 Bottle variant at 26.00 as a full-price line. It only stayed
       hidden because every product using this picker so far is named in
       single_unit_handles and took the 'single' branch instead. */
    var hasTierRows = !!root.querySelector('[data-tier]');

   /* Look for a preselected free scent option in the markup */
var initialFreeEl = root.querySelector('[data-freescent-option][aria-selected="true"], [data-freescent-option].selected, input[name="free_scent"]:checked');
var initialFreeVariant = freeVariants[0];

if (initialFreeEl) {
  var preselectedFreeId = initialFreeEl.dataset.variantId || initialFreeEl.value;
  if (preselectedFreeId) {
    initialFreeVariant = byFreeId(preselectedFreeId) || initialFreeVariant;
  }
}

var state = {
  variant: initialVariant,
  freeVariant: initialFreeVariant, // Uses preselected option if found
  tier: initialTier
    ? initialTier.dataset.tier
    : singleUnit
      ? 'single'
      : hasTierRows
        ? 'bogo'
        : 'multi'
};

    /* ---------- helpers ---------- */

    function setText(sel, value) {
      var el = root.querySelector(sel);
      if (el) el.textContent = value || '';
    }

    function setImage(sel, src) {
      var el = root.querySelector(sel);
      if (!el) return;
      if (src) {
        el.setAttribute('src', src);
        el.hidden = false;
      } else {
        el.removeAttribute('src');
        el.hidden = true;
      }
    }

    /* The upsell popup locks page scroll while it is open. Anything that can hide
       it has to release that lock, or the page is left with no scrollbar and no
       way to scroll — clicking where the scrollbar was does nothing, because
       <html> is still overflow:hidden. Keyed on "no popup is open anywhere"
       rather than on who called, so two overlapping close paths cannot leave the
       lock on or tear it down while a second popup is still up.

       The video lightbox counts as open anywhere. It takes the same lock from
       another file, and opening it clicks through to the close-on-outside
       handler here — which used to run this and release a lock it had just
       taken, leaving the page scrolling behind the panel. */
    function syncScrollLock() {
      var stillOpen =
        document.querySelector('[data-pdp-upsell][data-open="true"]') ||
        document.querySelector('[data-vr-lightbox][data-open]');
      document.documentElement.style.overflow = stillOpen ? 'hidden' : '';
    }

    function closeAll() {
      var open = root.querySelectorAll('[data-open="true"]');
      for (var i = 0; i < open.length; i++) {
        open[i].dataset.open = 'false';
        var t = open[i].querySelector('[aria-expanded]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      // closeAll sweeps every open panel, the upsell popup included.
      syncScrollLock();
    }

    function markSelected(list, id) {
      var opts = root.querySelectorAll(list);
      for (var i = 0; i < opts.length; i++) {
        opts[i].setAttribute('aria-selected', String(opts[i].dataset.variantId) === String(id) ? 'true' : 'false');
      }
    }

    /* ---------- render ---------- */

    function renderVariant() {
      var v = state.variant;

      setImage('[data-scent-image]', v.image);

      setText('[data-scent-name]', v.title);
      setText('[data-scent-tagline]', v.tagline);
      setText('[data-scent-notes]', v.notes);
      markSelected('[data-scent-option]', v.id);

      /* Headline + product name line, driven by the selected scent — but only
         when there IS a scent to name. A single-variant product (the hair mist)
         has one variant Shopify calls "Default Title", so overwriting here would
         print "FORCHICS Default Title". Leave whatever Liquid rendered. */
      /* Also off where the variants are not what the product is called. The
         refill's are "Shampoo" and "Conditioner" — the refill type, not a scent —
         so this printed "FORCHICS Shampoo" over a supplement. The tier guard below
         does not catch it: those tiers are BOGO-backed, not variant-backed. */
      var nameFollowsVariant = root.dataset.nameFollowsVariant !== 'false';
      if (variants.length > 1 && !variantBackedTiers && nameFollowsVariant) {
        /* The prefix used to carry its own trailing space, which the theme editor
           strips the moment anyone saves the section — that shipped "FORCHICSNoir".
           Put the separator in here instead, where nothing can trim it.

           Skipped entirely where the tiers are variant-backed: there the variant
           titles are "Buy 1" and "Buy 2", so naming the product after the selected
           one printed "FORCHICS Buy 2" on the two density pages. */
        var prefix = (root.dataset.namePrefix || '').trim();
        setText('[data-buy-product-name]', prefix ? prefix + ' ' + v.title : v.title);
      }
      if (v.headline) setText('[data-buy-headline]', v.headline);

      /* Tier prices follow the scent — except where the tiers are variant-backed
         ("Buy 1" and "Buy 2" as separate SKUs). There each tier has its own
         price, and writing the selected variant's figures into both would make
         the unselected tier quote the wrong money. */
      if (!variantBackedTiers) {
        setTierPrice('[data-tier1-price]', v.priceText, v.subPriceText);
        setTierPrice('[data-tier1-compare]', v.hasCompare ? v.compareText : '', v.hasSubCompare ? v.subCompareText : '');
        /* A tier selling more than one unit is priced in Liquid, where the
           multiplication happens with the money filter. Restating it from a
           single variant's figures here would quote one unit for two. */
        if (tier2Units < 2) {
          setTierPrice('[data-tier2-price]', v.priceText, v.subPriceText);
          setTierPrice('[data-tier2-compare]', v.bogoCompareText, v.subBogoCompareText);
        }
      }

      // The free scent is deliberately independent — changing the paid scent
      // must not move it.
      var input = root.querySelector('[data-variant-input]');
      if (input) input.value = v.id;
    }

    function renderFree() {
      var f = state.freeVariant;
      setImage('[data-freescent-image]', f.imageSmall || f.image);
      setText('[data-freescent-name]', f.title);
      markSelected('[data-freescent-option]', f.id);
      if (f.unitCompareText) setText('[data-freescent-compare]', f.unitCompareText);

      // Gift 1 tracks whichever free scent is chosen.
      var gift1 = root.querySelector('[data-free-gift-input="1"]');
      if (gift1) gift1.value = f.id;
    }

    // The button mirrors the selected offer's already-formatted prices.
    function renderAtcPrices() {
      var badge = root.querySelector('[data-pdp-atc-prices]');
      if (!badge) return;
      var tier = root.querySelector('[data-tier][data-selected="true"]');
      var price = tier && tier.querySelector('[data-tier1-price], [data-tier2-price]');
      var compare = tier && tier.querySelector('[data-tier1-compare], [data-tier2-compare]');
      var currentText = price ? price.textContent.trim() : '';
      var compareText = compare ? compare.textContent.trim() : '';
      var currentTarget = badge.querySelector('[data-pdp-atc-current]');
      var compareTarget = badge.querySelector('[data-pdp-atc-compare]');
      currentTarget.textContent = currentText;
      compareTarget.textContent = compareText;
      compareTarget.hidden = !compareText || compareText === currentText;
      badge.hidden = !currentText;
    }

    function renderTier() {
      var tiers = root.querySelectorAll('[data-tier]');
      for (var i = 0; i < tiers.length; i++) {
        tiers[i].dataset.selected = tiers[i].dataset.tier === state.tier ? 'true' : 'false';
      }

      // The free-gift properties belong to whichever tier carries the gifts.
      var gifts = root.querySelectorAll('[data-free-gift-input]');
      for (var g = 0; g < gifts.length; g++) {
        gifts[g].disabled = state.tier === 'single';
      }
      renderAtcPrices();
    }

    /* ---------- bundle picker ----------

       snippets/28-product-custom_variants_picker.liquid is a plain radio list
       carried over from the legacy PDP, and nothing here ever read it. It marks
       "4 Bottles" checked in Liquid, while state.variant stayed on variants[0],
       so the page showed 4 Bottles selected at $17.75/each and sent the cart one
       bottle at $23.40 - and picking another tier changed neither. Every add on
       this template billed a quarter of what was chosen.

       Read as `change` rather than `click` so the label, the input and the
       keyboard all arrive by one path. */
    /* Put the chosen tier in the URL.

       Naveed: come back from checkout and all four gifts sit unlocked for a
       second or two before collapsing to one. Timed on a back navigation, the
       cause is the browser, not this script:

         DOMContentLoaded      radio = 4 Bottle   t=3936
         rAF after DCL         radio = 4 Bottle   t=3950
         readyState complete   radio = 1 Bottle   t=5055   <- restoration
         pageshow              radio = 1 Bottle   t=5059   <- the re-sync, +4ms

       Chrome restores which radio is checked BETWEEN DOMContentLoaded and load,
       1.1s in on this page, and until then the page genuinely has the default
       tier selected. The re-sync then costs 4ms, so there is nothing to speed up
       there - the wrong paint has to stop being served in the first place.

       So the tier goes in the URL. Shopify resolves ?variant= into
       selected_or_first_available_variant, which is what the gifts block counts
       for its first paint, so coming back renders the chosen tier and its own
       gift count with no JavaScript involved - checked at ?variant=<1 Bottle>,
       which serves exactly one card active and one input enabled.

       replaceState, not pushState: a tier click must not become a history entry,
       or Back would walk the customer through their own tier changes instead of
       leaving the page. Other parameters are left alone - the perfume pages carry
       ?scent= - and those pages have no block swatches, so nothing here runs for
       them. pageshow stays as the backstop for a browser that restores something
       other than what the URL says. */
    function writeVariantToUrl(variantId) {
      if (!variantId) return;
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') === String(variantId)) return;
        url.searchParams.set('variant', variantId);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {
        /* Older browser, or an opaque origin. The pageshow re-sync still covers it. */
      }
    }

    function syncPickerVariant() {
      var radios = root.querySelectorAll('input.block-swatch__radio[variant-id]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          state.variant = byId(radios[i].getAttribute('variant-id'));
          return true;
        }
      }
      return false;
    }

    /* The gifts block draws one card per gift and unlocks them by unit count: an
       inactive card shows a padlock and the tier that would earn it, styling the
       block already carries. Liquid renders the state for the tier that opens
       selected; keeping it in step afterwards is this, and the disabled flags it
       sets are what addFreeGifts reads to decide which gifts go in the cart.

       The unit count comes off the variant title ("3 Bottles"), the same way the
       legacy PDP reads it. A title carrying no number means the product is not
       sold in units, and the cards are left exactly as Liquid drew them. */
    function renderGiftTier() {
      var form = root.querySelector('.free-gifts-form');
      if (!form) return;

      var cards = form.querySelectorAll('.free-gift-scooper');
      if (!cards.length) return;

      var match = /(\d+)/.exec(state.variant.title || '');
      if (!match) return;
      var earned = parseInt(match[1], 10);

      for (var i = 0; i < cards.length; i++) {
        var on = i < earned;
        if (on) cards[i].classList.add('active');
        else cards[i].classList.remove('active');

        var ins = cards[i].querySelectorAll('input');
        for (var j = 0; j < ins.length; j++) ins[j].disabled = !on;
      }
    }

    /* ---------- subscription pricing ----------

       Recharge discounts the unit price when the customer picks the monthly
       ritual. Both states are formatted in Liquid and parked on the price
       elements, so this only swaps which string shows — no money formatting
       here, which would drift from the store's currency settings. */
    function subscriptionOn() {
      /* Locked on, from the section setting: the page has no switch because the
         thing it sold is already the subscription. Checked before the switch so
         a page can lock on whether or not the ritual block is present. */
      if (root.hasAttribute('data-ritual-locked')) return true;

      var sw = root.querySelector('[data-ritual-toggle]');
      return !!sw && sw.getAttribute('aria-checked') === 'true';
    }

    /* True when each tier sells its own SKU, in which case the tier figures are
       fixed by Liquid and the selected variant must not restate them. */
    var variantBackedTiers = !!root.querySelector('[data-tier][data-tier-variant]');
    var bodyVariantBundle = !!root.querySelector('[data-body-variant-bundle]');
    var pricesFollowRitual = !!root.querySelector('[data-prices-follow-ritual]');

    /* Keep each Body Oil page's bundle choice through checkout and reloads.
       sessionStorage is tab-local; failures must never block purchasing. */
    var bodyOilSelectionKey = bodyVariantBundle
      ? 'forchics:body-oil-selection:' + window.location.pathname.replace(/\/$/, '')
      : '';

    function rememberBodyOilSelection() {
      if (!bodyOilSelectionKey) return;
      try {
        window.sessionStorage.setItem(bodyOilSelectionKey, JSON.stringify({
          tier: state.tier,
          variantId: String(state.variant.id),
          freeVariantId: state.freeVariant ? String(state.freeVariant.id) : '',
          ritualOn: subscriptionOn()
        }));
      } catch (e) {}
    }

    function restoreBodyOilSelection() {
      if (!bodyOilSelectionKey) return false;
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(bodyOilSelectionKey));
        if (!saved) return false;
        var tiers = root.querySelectorAll('[data-tier][data-tier-variant]');
        var matchedTier = null;
        for (var i = 0; i < tiers.length; i++) {
          if (tiers[i].dataset.tier === saved.tier &&
              String(tiers[i].dataset.tierVariant) === saved.variantId) {
            matchedTier = tiers[i];
            break;
          }
        }
        if (!matchedTier) return false;
        var matchedVariant = null;
        for (var v = 0; v < variants.length; v++) {
          if (String(variants[v].id) === saved.variantId && variants[v].available) {
            matchedVariant = variants[v];
            break;
          }
        }
        if (!matchedVariant) return false;
        state.tier = saved.tier;
        state.variant = matchedVariant;
        for (var f = 0; f < freeVariants.length; f++) {
          if (String(freeVariants[f].id) === saved.freeVariantId && freeVariants[f].available !== false) {
            state.freeVariant = freeVariants[f];
            break;
          }
        }
        var ritual = root.querySelector('[data-ritual-toggle]');
        if (ritual && !root.hasAttribute('data-ritual-locked') && typeof saved.ritualOn === 'boolean') {
          ritual.setAttribute('aria-checked', String(saved.ritualOn));
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    function resyncBodyOilSelection() {
      if (!restoreBodyOilSelection()) return;
      renderVariant();
      renderFree();
      renderTier();
      renderSubscriptionPrices();
    }


    /* How many units tier two sells. Two when its discount comes from Recharge,
       which takes its cut off every unit instead of making one of them free. */
    var tier2Units = (function () {
      var el = root.querySelector('[data-tier][data-tier-units]');
      var n = el ? parseInt(el.dataset.tierUnits, 10) : 1;
      return n > 1 ? n : 1;
    })();

    /* Restates a tier price for a new variant. Both states are stored back onto
       the element so a later toggle still has something to swap to, then the
       current one is painted. */
    function setTierPrice(selector, plain, sub) {
      var el = root.querySelector(selector);
      if (!el) return;
      if (sub === undefined || sub === null) sub = plain;
      if (el.dataset.comparePlain !== undefined) {
        el.dataset.comparePlain = plain;
        el.dataset.compareSub = sub;
      } else {
        el.dataset.pricePlain = plain;
        el.dataset.priceSub = sub;
      }
      // Body oil's one-time purchase uses its regular price; other pages keep their pricing behavior.
      el.textContent = pricesFollowRitual && !subscriptionOn() ? plain : sub;
    }

    function renderSubscriptionPrices() {
      var showSubscription = !pricesFollowRitual || subscriptionOn();
      var nodes = root.querySelectorAll('[data-price-plain], [data-compare-plain]');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var plain = el.dataset.pricePlain !== undefined ? el.dataset.pricePlain : el.dataset.comparePlain;
        var sub = el.dataset.priceSub !== undefined ? el.dataset.priceSub : el.dataset.compareSub;
        var next = showSubscription && sub !== undefined ? sub : plain;
        if (next === undefined) continue;
        el.textContent = next;
      }
      renderAtcPrices();
    }

    /* ---------- cart payload ---------- */

    /* Collects every enabled hidden properties[...] input, as a native form submit
           would, keeping the free-gift ids declarative in the Liquid. */
    function formProperties() {
      var props = {};
      var inputs = root.querySelectorAll('input[name^="properties["]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].disabled || !inputs[i].value) continue;
        var key = inputs[i].name.slice('properties['.length, -1);
        if (key) props[key] = inputs[i].value;
      }
      return props;
    }

    /* Only variant ids may go into line-item properties: mini-cart.liquid turns
           every property into an input the cart's removal handler feeds to
           cart/update.js as a key, so a label like "bogo" would 422 the request. */
    /* Whether a distinct bonus SKU backs the free line. The section only emits the
       free variant payload when the tiers block names a separate product; without
       one the free list falls back to this product's own variants. */
    var hasSeparateFree = !!root.querySelector('[data-pdp-free-variant-data]');

    function buildCartItems() {
      /* Built in the order the cart should READ, top to bottom:
             1 the product being paid for
             2 the free twin tier two promises
             3 any extra gift on top of it
             4 the gift card
         and reversed at the end, because the cart lists the most recently added
         line first. Sending it in reading order put the gift card at the top and
         the product the customer chose at the bottom. */
      var items = [{ id: state.variant.id, quantity: 1, properties: formProperties() }];

      /* Tier two is a two-item offer however it is priced — 'bogo' when one
         variant is charged once for both, 'multi' when each tier is its own SKU —
         and both advertise the bonus item and the gift card, so both add them.
         The difference is the second unit: BOGO's is this same variant, so it is
         pushed again; a variant-backed tier already IS two units, and pushing its
         variant twice would charge for four. That one only adds a distinct SKU. */
      if (state.tier !== 'single') {
        /* The free twin, where the picker is not it. Body oil v2 points the
           picker at the perfumes, so without this the free OIL the tier promises
           was never added — the customer got one oil and a perfume. Blank on
           every other template, which leaves their carts unchanged. */
        var bonus = root.dataset.bonusVariant;
        // A Buy 2 variant already contains both oils; keep only the extra gifts.
        if (bonus && !bodyVariantBundle) {
          items.push({ id: Number(bonus), quantity: 1 });
        }

        if (state.freeVariant && (state.tier === 'bogo' || hasSeparateFree)) {
          items.push({ id: state.freeVariant.id, quantity: 1 });
        }
        // Only added when a discount actually zeroes the line, otherwise the
        // customer is charged for it.
        var gc = root.dataset.giftcardVariant;
        if (gc && root.dataset.giftcardToCart === 'true') {
          items.push({ id: Number(gc), quantity: 1 });
        }
      }

      /* ---- Free gifts: added here, by the theme ----

         Turned back on 2026-09-02 after a day off. The alternative was leaving the
         gifts out of the cart entirely, which is worse than the cosmetic warning
         they cause, so this stands until the BOGOS offer exists.

         Known cost, and it is not a bug in this line: the gifts are BOGOS's own
         products - E-Book and Free Shipping both carry "vendor": "BOGOS" - so
         adding them from here puts them in the cart without the app registering an
         offer against them, and its checkout function then shows "The cart does not
         meet the offer's condition". Verified non-blocking: totals are right, the
         gifts read FREE, every payment method works. It fires on any tier, any
         plan and one-time too, and the legacy PDP has always done the same.

         Two ways out, neither of them here:
           - configure the offer in the BOGOS admin so the app grants the gifts,
             then comment this call again;
           - or point the gift settings at plain $0 products that no BOGOS offer
             owns, and the app has nothing of its own to object to.
      */
      addFreeGifts(items);

      /* applySellingPlan reads items[0] as the main line, so it runs before the
         reverse rather than after. */
      return applySellingPlan(items).slice().reverse();
    }

    /* The free-gifts block (snippets/28-product-free-gifts-addon.liquid) renders a
       standalone <form class="free-gifts-form"> of items[n][id] inputs, inherited
       from the legacy PDP where a native form submit posted it. The 28 buy box has
       no form at all - 28-product-form.js builds the payload itself - so nothing
       ever submitted it and the gifts never reached the cart. Read the inputs here
       instead and append them as real lines.

       Which gifts are earned is the block's business, not ours: it disables the
       inputs the current tier has not unlocked, so the enabled ones ARE the answer.

       Two things are written, because the cart drawer needs both. The lines put the
       gifts in the cart; the `_free gift n` properties on the main line are what
       cart-drawer-v2-line-item.liquid reads back to mirror quantity onto the gifts
       and to remove them when the paid line goes - without them a customer can
       delete what they paid for and keep a cart of gifts. */
    function addFreeGifts(items) {
      var form = root.querySelector('.free-gifts-form');
      if (!form || !items.length) return items;

      /* Gifts that are shown but never added.

         Per Naveed: the Free Shipping tile stays in the row exactly as it is, and
         the product behind it stops being put in the cart. It is a placeholder SKU
         standing in for a shipping perk - the tile is the message, the line was
         only ever a side effect of using a product to represent it, and it brought
         a row to hide and a counter to correct with it.

         The same list the drawer and the header count read, from
         snippets/cart-hidden-line-handles via js-variables, so a handle named once
         is not shown, not counted and now not added. Those two still matter: a
         customer whose cart already holds the SKU keeps a tidy drawer.

         Nothing here touches what is drawn. The tile renders, unlocks and reads
         FREE as before; only the payload is shorter. And no `_free gift n`
         property is written for it, because that is written where the line is
         pushed - so the cascade in assets/custom.js has nothing to look for. */
      var themeSettings = (window.themeVariables && window.themeVariables.settings) || {};
      var displayOnlyGifts = themeSettings.cartHiddenHandles || [];

      var inputs = form.querySelectorAll('input.js-product_id_input');
      var n = 0;
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.disabled) continue;

        var giftHandle = input.dataset.giftHandle || '';
        if (giftHandle && displayOnlyGifts.indexOf(giftHandle) !== -1) {
          /* Earned, but not a line. The loop has already skipped the disabled
             inputs, so reaching here means this tier unlocked the tile - and the
             customer IS entitled to the perk even though no product carries it.

             Per Naveed: the drawer bar has to read as met in that case. Nothing
             else in the cart says so once the product stopped being added, so the
             fact is recorded on the paid line and the drawer reads it back.

             Underscored, so Shopify hides it at checkout and the drawer keeps it
             out of the customer-facing property list. cart-drawer-v2-line-item
             skips this one key when it collects gift ids, or the marker would be
             mistaken for a variant to remove. */
          items[0].properties['_free shipping'] = 'earned';
          continue;
        }

        var id = Number(input.value);
        if (!id) continue;

        /* Price is no longer a reason to skip a gift.

           This used to skip anything not priced 0.00 unless the block declared
           gifts_zeroed_by_discount, and that flag is why Naveed saw the gifts stop
           adding on the lash serum: the theme editor re-serialised
           product.28-eyelash-serum.json and the checkbox came back false, so every
           gift was skipped and the payload went out with the paid line alone. A
           checkbox the editor can quietly reset is not where this protection
           belongs.

           dropChargedGifts now does the protecting, after the add, against the real
           cart: anything named as a gift that came back above zero is taken out. So
           the gifts are always offered and never charged, and there is nothing left
           to configure or to reset. */

        items.push({ id: id, quantity: 1 });
        items[0].properties['_free gift ' + n] = String(id);
        n++;
      }
      return items;
    }

    /* The variant -> recurring selling plan map the section emits. Parsed once;
       an absent node means this product has no subscription at all. */
    var planMap;
    function sellingPlans() {
      if (planMap) return planMap;
      planMap = {};
      var node = root.querySelector('script[data-selling-plans]');
      if (node) {
        try {
          planMap = JSON.parse(node.textContent) || {};
        } catch (e) {
          planMap = {};
        }
      }
      return planMap;
    }

    /* With the ritual switch on, the subscription goes on the product being sold
       and nothing else. The BOGO bonus SKU and the gift card ride along as
       one-time lines: they are what makes the offer, not part of the recurring
       order, and committing them to a recurring charge nobody chose would be
       worse than not discounting them. items[0] is always the main line — see
       buildCartItems. */
    function applySellingPlan(items) {
      if (!subscriptionOn() || !items.length) return items;

      /* Recharge sells the subscription as a separate product, so where the
         scent names a twin the line has to BECOME that variant - adding a plan
         to the one-time variant would fail, since the plan does not belong to
         it. The paid variant is still what the page priced and displayed; only
         the id sent to /cart/add changes, and only while the switch is on. */
      var v = state.variant;
      if (v && v.subVariantId) {
        items[0].id = Number(v.subVariantId);
        if (v.subPlanId) items[0].selling_plan = Number(v.subPlanId);
        return items;
      }

      var plan = sellingPlans()[items[0].id];
      if (plan) items[0].selling_plan = plan;
      return items;
    }

    // Exposed so the ATC block can call it once that block exists.
    root.pdpBuyBox = {
      getItems: buildCartItems,
      getState: function () {
        return { tier: state.tier, variantId: state.variant.id, freeVariantId: state.freeVariant.id };
      }
    };

    function themeSetting(key, fallback) {
      var v = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings[key];
      return v == null ? fallback : v;
    }

    /* Something the customer can act on, for when the response carries no
       message of its own. */
    function statusMessage(status) {
      if (status >= 500 || !status) return 'The store is busy right now. Please try again in a moment.';
      if (status === 404) return 'That item is no longer available.';
      if (status === 401 || status === 403) return 'Your session expired. Please refresh the page and try again.';
      if (status === 429) return 'Too many attempts. Please wait a moment and try again.';
      return 'We could not add that to your cart. Please try again.';
    }

    /* Cart endpoints normally answer with JSON, but a proxy hiccup, a 5xx or a
           redirect to the password page returns an empty body or HTML. res.json() then
           throws and the customer sees a DOMException, so read the text and decide
           from the status. */
    function readCartJson(res) {
      return res.text().then(function (text) {
        var body = null;
        if (text) {
          try {
            body = JSON.parse(text);
          } catch (e) {
            /* Not JSON. Fall through to the status-based message. */
          }
        }

        if (!res.ok) {
          throw new Error((body && (body.description || body.message)) || statusMessage(res.status));
        }
        if (!body) {
          throw new Error(statusMessage(res.status));
        }
        return body;
      });
    }

    /* ---------- the cart drawer ----------

       The drawer's element name is not fixed: the theme shipped <cart-drawer>
       from sections/mini-cart.liquid and now renders <cart-drawer-v2> from a
       newer section. Both carry id="mini-cart", so look that up first and treat
       the tag names as the fallback. Hardcoding one of them is what sent every
       add-to-cart to /cart — openCart could not find a drawer, so it took its
       "no drawer on this theme" branch. */
    function drawerEl() {
      return document.getElementById('mini-cart') || document.querySelector('cart-drawer, cart-drawer-v2');
    }

    /* The section to ask for when re-rendering it. The element names it, so this
       follows the theme rather than assuming. */
    function drawerSection() {
      var d = drawerEl();
      return (d && d.getAttribute('section')) || 'mini-cart';
    }

    /* Whether the drawer's own script is running. cart-drawer-v2's section
       references assets that are not on the theme, so its custom element is
       never defined: nothing listens for cart:refresh and nothing re-renders it.
       When that is the case this file does both jobs itself; when the script is
       present it is left alone to do them. */
    function drawerHasScript() {
      var d = drawerEl();
      if (!d) return false;
      var tag = d.tagName.toLowerCase();
      if (tag.indexOf('-') < 0) return false;
      return !!(window.customElements && window.customElements.get(tag));
    }

    /* Swaps in freshly rendered section markup, for the no-script case. Returns
       the new element, since replacing the markup discards the old node. */
    function renderDrawer(html) {
      var id = 'shopify-section-' + drawerSection();
      var wrapper = document.getElementById(id);
      if (!wrapper || !html) return drawerEl();

      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById(id) || parsed.body.firstElementChild;
      if (!fresh) return drawerEl();

      wrapper.innerHTML = fresh.innerHTML;
      return drawerEl();
    }

    /* Mirrors the theme's own add-to-cart flow: request the drawer's section
           alongside the add, then dispatch cart:updated and cart:refresh so the drawer
           opens and re-renders. Falls back to the cart page only in that mode. */
    /* POSTs a set of line items, then reveals the cart. Resolves only after the
       drawer is open, so callers know when it is safe to close the popup. */
    var cartRequestPending = false;

    function submitCart(items) {
      cartRequestPending = true;
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      return fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items, sections: [drawerSection()], sections_url: window.location.pathname })
      })
        .catch(function () {
          /* fetch itself rejected, so there is no response to read — offline,
             DNS, or the request was blocked. */
          throw new Error('Could not reach the cart. Check your connection and try again.');
        })
        .then(readCartJson)
        .then(dropChargedGifts)
        .then(function (added) {
          return openCart(added);
        })
        .finally(function () { cartRequestPending = false; });
    }

    /* Never let a gift be charged.

       The gift SKUs are real products with real prices - Eyelash 39.00, Hair Spray
       59.95, Eyebrow 39.00, Mascara 25.00, Free Shipping 5.95 - and an automatic
       discount is what takes them to 0.00. addFreeGifts adds whatever the tier
       unlocked without looking at the price, so this is the only thing standing
       between a lapsed discount and a charge. Naveed saw both halves of that: three
       gifts in the cart at full price under tiles reading FREE, 69.95 of them, and
       later no gifts at all when a checkbox tried to do this job instead.

       So the trust is verified now rather than assumed. /cart/add.js answers with
       the whole cart, discounts already allocated, so the moment the add lands we
       can see whether each gift really came in free. Any that did not is taken
       straight back out. The customer loses a gift the offer could not honour,
       which is the right way round - they are never charged for one.

       Which lines are gifts is not guessed from the price: buildCartItems names
       each one in `_free gift n` on the paid line, and that is what is read here -
       the same list assets/custom.js uses to clear the gifts when the paid line
       goes. /cart/change.js takes the drawer section too, so the removal re-renders
       in the same round trip and the drawer opens on a cart that is already right.

       Failing quietly is deliberate: if the check cannot run, the add has already
       succeeded and the cart is no worse than before this existed. */
    function dropChargedGifts(added) {
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      /* The whole cart, not the add response. /cart/add.js answers with the lines
         it just added, so reading that would only ever police this add - a cart
         already holding a charged gift, which is exactly the state Naveed was
         looking at, would stay broken until it was emptied by hand. */
      var snapshot = null;
      var html = added && added.sections && added.sections[drawerSection()];
      if (html) {
        try {
          var section = new DOMParser().parseFromString(html, 'text/html');
          var data = section.querySelector('[data-pdp-cart-state]');
          if (data) snapshot = JSON.parse(data.textContent);
          if (!snapshot || !Array.isArray(snapshot.items) || typeof snapshot.item_count !== 'number') snapshot = null;
        } catch (error) { snapshot = null; }
      }
      var cartRead = snapshot ? Promise.resolve(snapshot) :
        fetch(root_url + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; });
      return cartRead
        .then(function (cart) {
          if (!cart || !cart.items) return added;
          added._pdpCart = cart;
          if (!cart.items.length) return added;

          var giftIds = {};
          cart.items.forEach(function (line) {
            var props = line.properties || {};
            Object.keys(props).forEach(function (name) {
              /* Plain string matching, not a regex. This was /frees*gift/i and the
                               backslash was lost on the way in, leaving /frees*gift/i - which
                               matches nothing a property is ever called, so the guard silently
                               never fired. The names are `_free gift 0`, `_free gift 1`. */
                            var giftKey = String(name).toLowerCase();
                            if (props[name] && (giftKey.indexOf('free gift') >= 0 || giftKey.indexOf('freegift') >= 0)) {
                              giftIds[String(props[name])] = true;
                            }
            });
          });
          if (!Object.keys(giftIds).length) return added;

          var charged = cart.items.filter(function (line) {
            if (!giftIds[String(line.variant_id)]) return false;
            if (line.final_line_price <= 0) return false;
            /* Quantity one only. The gift SKUs are dedicated products - the
               -bogo twins and the free-* ones - so nothing a customer can buy
               merges into a gift line, and a line of two means something this
               code does not understand. Leave it and say so rather than delete
               something that was paid for. */
            if (line.quantity !== 1) {
              if (window.console && console.warn) {
                console.warn('[buy box] a priced gift line has quantity ' + line.quantity + ', left alone: ' + line.product_title);
              }
              return false;
            }
            return true;
          });
          if (!charged.length) return added;

          if (window.console && console.warn) {
            console.warn(
              '[buy box] a free gift came back priced and was removed: ' +
                charged
                  .map(function (l) { return l.product_title + ' ' + l.final_line_price; })
                  .join(', ')
            );
          }

          return charged.reduce(function (chain, line) {
            return chain.then(function (latest) {
              return fetch(root_url + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: String(line.key), quantity: 0, sections: [drawerSection()], sections_url: window.location.pathname })
              })
                .then(function (res) { return res.ok ? res.json() : latest; })
                .then(function (next) {
                  if (!next || !next.items) return latest;
                  next._pdpCart = Object.assign({}, next);
                  return next;
                });
            });
          }, Promise.resolve(added));
        })
        .catch(function () { return added; });
    }

    /* The upsell must appear the instant the button is pressed, so nothing is sent
           yet: the selection is snapshotted and the popup's buttons carry out the add.
           Without a popup this is a plain add-to-cart. */
    var pendingItems = null;

    function addToCart(button) {
      if (cartRequestPending) return Promise.resolve();
      var errorEl = root.querySelector('[data-atc-error]');
      if (errorEl) errorEl.textContent = '';

      var popup = root.querySelector('[data-pdp-upsell]');
      if (popup) {
        pendingItems = buildCartItems();
        openUpsell(popup);
        return Promise.resolve();
      }

      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('disabled', 'disabled');
      }

      return submitCart(buildCartItems())
        .catch(function (err) {
          if (errorEl) errorEl.textContent = err.message;
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-busy');
            button.removeAttribute('disabled');
          }
        });
    }

    /* ---------- upsell popup ---------- */

    var upsellTimer = null;

    function openUpsell(popup) {
      popup.dataset.open = 'true';
      popup.dataset.failed = 'false';
      syncScrollLock();

      // Clear any error from a previous attempt — the popup reopens on every add.
      var prevError = popup.querySelector('[data-upsell-error]');
      if (prevError) prevError.textContent = '';

      var countdown = popup.querySelector('[data-upsell-countdown]');
      var minutes = parseInt(popup.dataset.timerMinutes, 10);
      if (countdown && minutes > 0) {
        var remaining = minutes * 60;
        var tick = function () {
          var m = Math.floor(remaining / 60);
          var s = remaining % 60;
          countdown.textContent = m + ':' + (s < 10 ? '0' + s : s);
          if (remaining <= 0) {
            window.clearInterval(upsellTimer);
            upsellTimer = null;
            return;
          }
          remaining -= 1;
        };
        tick();
        if (upsellTimer) window.clearInterval(upsellTimer);
        upsellTimer = window.setInterval(tick, 1000);
      }
    }

    function closeUpsell(popup) {
      popup.dataset.open = 'false';
      syncScrollLock();
      if (upsellTimer) {
        window.clearInterval(upsellTimer);
        upsellTimer = null;
      }
    }

    /* Open the drawer immediately, without exposing stale totals or checkout
       while Shopify confirms the selected bundle and checks its free gifts. */
    var pendingDrawerState = null;

    function showPendingDrawer(popup) {
      var drawer = drawerEl();
      if (!drawer || themeSetting('cartType', 'drawer') === 'page') return;
      var hidden = [];
      Array.prototype.forEach.call(drawer.children, function (child) {
        if (child.matches('header, .drawer__overlay')) return;
        hidden.push({ node: child, inert: child.hasAttribute('inert'), visibility: child.style.visibility });
        child.setAttribute('inert', '');
        child.style.visibility = 'hidden';
      });
      var status = document.createElement('div');
      status.setAttribute('data-pdp-cart-pending', '');
      status.setAttribute('role', 'status');
      status.className = 'spinner';
      status.setAttribute('aria-label', 'Loading cart');
      status.innerHTML = '<svg focusable="false" aria-hidden="true" width="32" height="32" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="6"></circle></svg>';
      status.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;align-items:center;justify-content:center;width:32px;height:32px;pointer-events:none;';
      drawer.appendChild(status);
      pendingDrawerState = { drawer: drawer, hidden: hidden, status: status };
      drawer.setAttribute('aria-busy', 'true');
      closeUpsell(popup);
      drawer.setAttribute('open', '');
    }

    function finishPendingDrawer() {
      if (!pendingDrawerState) return;
      var pending = pendingDrawerState;
      pending.hidden.forEach(function (entry) {
        entry.node.style.visibility = entry.visibility;
        if (!entry.inert) entry.node.removeAttribute('inert');
      });
      pending.status.remove();
      pending.drawer.removeAttribute('aria-busy');
      pendingDrawerState = null;
    }

    function openCart(added) {
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var drawer = drawerEl();
      if (!drawer || themeSetting('cartType', 'drawer') === 'page') {
        window.location.href = root_url + 'cart';
        return Promise.resolve();
      }
      var sectionHtml = added && added.sections && added.sections[drawerSection()];
      var cartPromise = added && added._pdpCart
        ? Promise.resolve(added._pdpCart)
        : fetch(root_url + 'cart.js').then(readCartJson);
      // Bundled section rendering already returns the updated drawer. Only
      // fetch a section separately if Shopify did not include it in the response.
      var sectionPromise = sectionHtml ? Promise.resolve(sectionHtml) :
        fetch(window.location.pathname + '?section_id=' + encodeURIComponent(drawerSection()))
          .then(function (response) {
            if (!response.ok) throw new Error('Could not refresh your cart.');
            return response.text();
          });

      return Promise.all([cartPromise, sectionPromise]).then(function (result) {
        var cart = result[0];
        var parsed = new DOMParser().parseFromString(result[1], 'text/html');
        var fresh = parsed.getElementById(drawer.id) || parsed.querySelector(drawer.tagName.toLowerCase());
        if (!fresh) throw new Error('Could not refresh your cart.');
        var dismissedWhileLoading = pendingDrawerState && !drawer.hasAttribute('open');
        // Keep the custom element and its delegated handlers; replace only
        // its contents with the section from the completed cart mutation.
        drawer.innerHTML = fresh.innerHTML;
        drawer.nextReplacementDelay = 0;
        finishPendingDrawer();
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
        if (added && added.items && added.items.length) {
          var announced = added.items[0];
          for (var ai = 0; ai < added.items.length; ai++) {
            if (String(added.items[ai].id) === String(state.variant.id)) {
              announced = added.items[ai];
              break;
            }
          }
          drawer.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: announced } }));
          drawer.nextReplacementDelay = 0;
        }
        if (!dismissedWhileLoading) drawer.setAttribute('open', '');
        if (typeof window.shippingInsuranceAddRemove === 'function') window.shippingInsuranceAddRemove();
      }).catch(function () {
        // The add succeeded. Navigate to the current cart rather than asking
        // the customer to retry an add that would duplicate their items.
        finishPendingDrawer();
        window.location.href = root_url + 'cart';
      });
    }

    /* Both popup paths add the snapshotted selection; accepting appends the
       upsell line. Show the pending drawer immediately for either choice. */
    function resolveUpsell(popup, button, withUpsell) {
      if (cartRequestPending || popup.dataset.busy === 'true') return Promise.resolve();
      var items = (pendingItems || buildCartItems()).slice();

      if (withUpsell) {
        var id = Number(popup.dataset.variantId);
        /* Second from the end, not the end. The payload is in reverse — last
           sent shows first — so appending would put the add-on above the
           product it was offered alongside. Slotting it in just before the
           main line lands it directly beneath it, ahead of the free items. */
        if (id) items.splice(Math.max(0, items.length - 1), 0, { id: id, quantity: 1 });
      }

      var msg = popup.querySelector('[data-upsell-error]');
      if (msg) msg.textContent = '';
      if (button) button.setAttribute('aria-busy', 'true');
      popup.dataset.busy = 'true';
      showPendingDrawer(popup);

      return submitCart(items)
        .then(function () {
          pendingItems = null;
          closeUpsell(popup);
        })
        .catch(function (err) {
          // Surface why rather than closing silently — an out-of-stock upsell
          // would otherwise look like the button simply did nothing. Both
          // buttons come back, so nobody is trapped.
          if (pendingDrawerState) {
            pendingDrawerState.drawer.removeAttribute('open');
            finishPendingDrawer();
          }
          openUpsell(popup);
          if (msg) msg.textContent = err.message;
          // The popup holds the page scroll while it is up, and every close
          // path goes through the cart. If the cart is what failed, that would
          // leave the page locked behind a popup that cannot be dismissed, so
          // the cross and Escape become a plain dismiss until the next open.
          popup.dataset.failed = 'true';
        })
        .finally(function () {
          popup.dataset.busy = 'false';
          if (button) button.removeAttribute('aria-busy');
        });
    }
    /* ---------- events (delegated on the section root) ---------- */

    function selectTier(tierEl) {
      state.tier = tierEl.dataset.tier;
      if (tierEl.dataset.tierVariant) {
        var picked = byId(tierEl.dataset.tierVariant);
        if (picked) {
          state.variant = picked;
          renderVariant();
        }
      }
      renderTier();
      rememberBodyOilSelection();
    }

    root.addEventListener('click', function (event) {
      var t = event.target;
      var clickedTier = t.closest('[data-tier]');
      // Select the body-oil card first, then let its dropdown controls handle the click.
      if (clickedTier && clickedTier.closest('[data-tier-card-select]')) {
        selectTier(clickedTier);
      }

      var scentToggle = t.closest('[data-scent-toggle]');
      if (scentToggle) {
        var scent = scentToggle.closest('[data-pdp-scent]');
        var wasOpen = scent.dataset.open === 'true';
        closeAll();
        scent.dataset.open = wasOpen ? 'false' : 'true';
        scentToggle.setAttribute('aria-expanded', String(!wasOpen));
        return;
      }

      var scentOpt = t.closest('[data-scent-option]');
      if (scentOpt) {
        state.variant = byId(scentOpt.dataset.variantId);
        renderVariant();
        closeAll();
        return;
      }

      var freeToggle = t.closest('[data-freescent-toggle]');
      if (freeToggle) {
        var fs = freeToggle.closest('[data-pdp-freescent]');
        var fsOpen = fs.dataset.open === 'true';
        closeAll();
        fs.dataset.open = fsOpen ? 'false' : 'true';
        freeToggle.setAttribute('aria-expanded', String(!fsOpen));
        return;
      }

      var freeOpt = t.closest('[data-freescent-option]');
      if (freeOpt) {
        state.freeVariant = byFreeId(freeOpt.dataset.variantId);
        renderFree();
        rememberBodyOilSelection();
        closeAll();
        return;
      }

      var tierBtn = t.closest('[data-tier-select]');
      if (tierBtn) {
        var tierEl = tierBtn.closest('[data-tier]');
        if (!tierEl.closest('[data-tier-card-select]')) {
          selectTier(tierEl);
        }
        return;
      }

      /* Subscription ritual switch: repaints the tiers at their subscribed
         prices, and buildCartItems puts the variant's plan on the line. */
      var ritual = t.closest('[data-ritual-toggle]');
      if (ritual) {
        event.preventDefault();
        ritual.setAttribute('aria-checked', ritual.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
        renderSubscriptionPrices();
        rememberBodyOilSelection();
        return;
      }

      var atc = t.closest('[data-pdp-atc]');
      if (atc) {
        event.preventDefault();
        addToCart(atc);
        return;
      }

      var upAdd = t.closest('[data-upsell-add]');
      if (upAdd) {
        event.preventDefault();
        resolveUpsell(upAdd.closest('[data-pdp-upsell]'), upAdd, true);
        return;
      }

      // Declining and the cross do the same thing, and the cross puts its
      // loader on the decline button so there is one place to look.
      var upSkip = t.closest('[data-upsell-decline]') || t.closest('[data-upsell-close]');
      if (upSkip) {
        event.preventDefault();
        var pop = upSkip.closest('[data-pdp-upsell]');
        if (pop.dataset.busy === 'true') return;
        if (pop.dataset.failed === 'true' && t.closest('[data-upsell-close]')) {
          closeUpsell(pop);
          return;
        }
        resolveUpsell(pop, pop.querySelector('[data-upsell-decline]'), false);
        return;
      }
    });

    // Escape takes the decline path, so the selection still reaches the cart.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var pop = root.querySelector('[data-pdp-upsell][data-open="true"]');
      if (!pop || pop.dataset.busy === 'true') return;
      if (pop.dataset.failed === 'true') {
        closeUpsell(pop);
        return;
      }
      resolveUpsell(pop, pop.querySelector('[data-upsell-decline]'), false);
    });

    /* FAQ: one open at a time, animated.

           A native <details> drops its content the moment `open` is removed, so a
           collapse cannot be transitioned in CSS. The summary's default action is
           prevented and `open` is driven here, which holds the element open for the
           length of the collapse. Height animates on .product-form-28__faq-body, which
           carries no padding for that reason. Enter and Space dispatch a click, so
           keyboard access still works. */
    var faqs = root.querySelectorAll('[data-pdp-faq]');
    var FAQ_MS = 240;

    function faqBody(details) {
      return details.querySelector('[data-faq-body]');
    }

    function faqReduceMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function faqSettle(details, body) {
      body.style.transition = '';
      body.style.height = '';
      details.dataset.faqAnimating = '0';
    }

    function faqExpand(details) {
      var body = faqBody(details);
      details.open = true;
      if (!body || faqReduceMotion()) return;

      details.dataset.faqAnimating = '1';
      var target = body.scrollHeight;
      body.style.transition = 'none';
      body.style.height = '0px';
      // Read back so the 0 height is committed before the transition starts.
      void body.offsetHeight;
      body.style.transition = 'height ' + FAQ_MS + 'ms ease';
      body.style.height = target + 'px';
      window.setTimeout(function () {
        faqSettle(details, body);
      }, FAQ_MS);
    }

    function faqCollapse(details) {
      var body = faqBody(details);
      if (!body || faqReduceMotion()) {
        details.open = false;
        return;
      }

      details.dataset.faqAnimating = '1';
      body.style.transition = 'none';
      body.style.height = body.scrollHeight + 'px';
      void body.offsetHeight;
      body.style.transition = 'height ' + FAQ_MS + 'ms ease';
      body.style.height = '0px';
      window.setTimeout(function () {
        details.open = false;
        faqSettle(details, body);
      }, FAQ_MS);
    }

    for (var f = 0; f < faqs.length; f++) {
      faqs[f].addEventListener('click', function (event) {
        if (!event.target.closest('summary')) return;
        event.preventDefault();
        if (this.dataset.faqAnimating === '1') return;

        if (this.open) {
          faqCollapse(this);
          return;
        }
        for (var j = 0; j < faqs.length; j++) {
          if (faqs[j] !== this && faqs[j].open && faqs[j].dataset.faqAnimating !== '1') {
            faqCollapse(faqs[j]);
          }
        }
        faqExpand(this);
      });
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll();
    });

    root.addEventListener('change', function (event) {
      var swatch = event.target && event.target.closest && event.target.closest('input.block-swatch__radio');
      if (!swatch || !swatch.getAttribute('variant-id')) return;
      state.variant = byId(swatch.getAttribute('variant-id'));
      writeVariantToUrl(state.variant && state.variant.id);
      renderVariant();
      renderGiftTier();
      renderSubscriptionPrices();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });

    /* Back and forward.

       The browser restores which radio is checked on a history navigation, and it
       does that AFTER this init has run and WITHOUT firing a change event. So the
       page showed the customer 1 Bottle selected while state.variant still held
       Liquid's default of 4 Bottles, and everything downstream followed the stale
       one: all four gifts unlocked, and Add to cart put 4 Bottles at $63.90 on a
       cart the page had priced at $23.40. Naveed found it through the gifts; the
       charge was the same fault.

       Re-read the DOM once the restore has landed and re-render from it, so the
       radio is the single source of truth. pageshow fires after load, which is
       after restoration, and covers the bfcache case too - there nothing has
       changed and this is a no-op. Guarded on syncPickerVariant finding a checked
       radio, so a page without this picker is left alone.

       The whole init tail, not just the gifts: the tier, the free line and the
       subscribed prices are read off the same variant and were equally stale. */
    function resyncFromPicker() {
      if (!syncPickerVariant()) return;
      renderVariant();
      renderFree();
      renderTier();
      renderGiftTier();
      renderSubscriptionPrices();
    }

    window.addEventListener('pageshow', function () {
      /* One more on the next frame: restoration order is not specified, and on a
         re-rendered back navigation it can land either side of pageshow. */
      resyncFromPicker();
      resyncBodyOilSelection();
      if (window.requestAnimationFrame) window.requestAnimationFrame(resyncFromPicker);
    });

    syncPickerVariant();
    restoreBodyOilSelection();
    renderVariant();
    renderFree();
    renderTier();
    renderGiftTier();
    renderSubscriptionPrices();
    initSocialHeights(root);
    initResultHeights(root);
  }

  /* ------------------------------------------------------------------
     "Try Today Risk Free" below the fold

     Those buttons carry data-pdp-atc, but the buy box binds its handler to its
     own root, so a click outside it never reached anything — the buttons did
     nothing. They should not add to the cart blind either: the customer has to
     pick a tier first. So they scroll up to the tier selector instead.
     ------------------------------------------------------------------ */

  /* Whatever is pinned to the top of the viewport, so the tiers do not land
     underneath it. Measured rather than hard-coded — the announcement bar and
     header differ per template. */
  function pinnedOffset() {
    var bottom = 0;
    var nodes = document.body.querySelectorAll('header, [class*="header"], [class*="announcement"], [class*="banner"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      if (r.height && r.top <= 1 && r.bottom > bottom) bottom = r.bottom;
    }
    return bottom;
  }

  /* Whatever is pinned to the BOTTOM of the viewport - on a phone that is the
     sticky add to cart bar, which is the very thing whose button triggers this.
     Centring has to happen inside what is actually visible, or the target lands
     half underneath it. */
  function pinnedBottomOffset() {
    var height = 0;
    var nodes = document.body.querySelectorAll('[data-sticky-atc], [class*="sticky"], [class*="bottom-bar"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      if (!r.height) continue;
      /* Anchored to the bottom edge, and actually on screen. */
      if (r.bottom < window.innerHeight - 1) continue;
      if (r.top >= window.innerHeight) continue;
      var visible = window.innerHeight - r.top;
      if (visible > height) height = visible;
    }
    return height;
  }

  function scrollToBuyBox() {
    var box = document.querySelector('[data-pdp-buybox-root]');
    if (!box) return false;

    /* What the scroll is FOR: the thing the customer has to choose from.

       Naveed, after the centring change: the variant picker should be in view.
       It was not the anchor - the list went straight from the bundle tiers to the
       add to cart block, and the pages using the custom variant picker have no
       tiers, so they centred the button and left the choice above it.

       .product-form__variants is that picker (product-variants, the element that
       holds the swatch list). It sits directly under .product-form-28 with no
       product-form-28__block wrapper of its own, which is why nothing here had
       ever matched it.

       Order is deliberate: a page with bundle tiers still centres those, since
       they are its choice UI; the picker is the same thing on the pages that use
       it instead; the button is the last resort for a page with neither. */
    var target =
      box.querySelector('[data-pdp-tiers]') ||
      box.querySelector('.product-form__variants') ||
      box.querySelector('.product-form-28__block--atc') ||
      box;

    /* Centred, not tucked under the header.

       This landed the target 12px below whatever is pinned at the top, so the
       add to cart button sat right at the top edge of the screen with the whole
       buy box below it - what Naveed circled. Centre it in the space between
       what is pinned above and what is pinned below instead.

       A target taller than that space cannot be centred, so it keeps the old
       top alignment: pushing its middle to the middle would put its top off
       screen, which is worse than what it replaced. */
    /* Centre the whole choice, button included.

       Centring the picker alone put the add to cart off screen on three of four
       pages measured - a poor place to land a button whose whole job is to be
       pressed. So the region measured is from the top of the picker to the bottom
       of the add to cart block, and that is what gets centred. Both ends fit in a
       phone viewport on every 28 PDP, checked below.

       A region taller than the space keeps the old top alignment, which puts the
       picker under the header and the button a short scroll away - the choice
       first, which is the order the page asks for them. */
    var rect = target.getBoundingClientRect();
    var regionTop = rect.top;
    var regionBottom = rect.bottom;

    var atcBlock = box.querySelector('.product-form-28__block--atc');
    if (atcBlock) {
      var atcRect = atcBlock.getBoundingClientRect();
      if (atcRect.bottom > regionBottom) regionBottom = atcRect.bottom;
    }

    var pinnedTop = pinnedOffset();
    var available = window.innerHeight - pinnedTop - pinnedBottomOffset();
    var gap = (available - (regionBottom - regionTop)) / 2;
    if (!(gap > 0)) gap = 12;

    var y = regionTop + window.pageYOffset - pinnedTop - gap;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });

    /* Move focus for keyboard and screen reader users without stealing the
       scroll position back. */
    var focusable = target.querySelector('input, button, [tabindex]');
    if (focusable && focusable.focus) focusable.focus({ preventScroll: true });
    return true;
  }

  document.addEventListener('click', function (event) {
    var cta = event.target.closest && event.target.closest('[data-pdp-atc], [data-pdp-atc-scroll]');
    if (!cta) return;
    /* Inside the buy box the real handler owns the click. */
    if (cta.closest('[data-pdp-buybox-root]')) return;
    if (scrollToBuyBox()) event.preventDefault();
  });

  /* The star rating jumps to the reviews. Preference order: the 28 heading that
     introduces them, then Loox's own container, then the app section that holds
     it — so this keeps working if the heading section is dropped from a template
     or Loox renames its wrapper. */
  function scrollToReviews() {
    var target =
      document.querySelector('[data-pdp-reviews]') ||
      document.querySelector('[class*="reviews-heading-28"]') ||
      document.getElementById('looxReviews') ||
      document.querySelector('.loox-widget, [id^="shopify-block-"][id*="loox"]');
    if (!target) return false;

    var y = target.getBoundingClientRect().top + window.pageYOffset - pinnedOffset() - 12;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-pdp-reviews-scroll]');
    if (!trigger) return;
    if (scrollToReviews()) event.preventDefault();
  });

  /* ------------------------------------------------------------------
     Sticky add to cart — Figma 13639:12766

     Down until the real Add to cart button leaves the viewport, up while it is
     away, down again the moment it returns. Its own click is already handled:
     the button carries data-pdp-atc-scroll, so the listener above sends it to
     the tier selector rather than posting a half-chosen cart.
     ------------------------------------------------------------------ */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || bar.dataset.stickyReady === '1') return;

    /* The element to watch is the real button, not the buy box: the buy box is
       tall enough on a phone that part of it is on screen long after the button
       has gone, which is exactly when the bar is wanted. */
    var anchor =
      document.querySelector('[data-pdp-buybox-root] [data-pdp-atc]') ||
      document.querySelector('[data-pdp-buybox-root]');
    if (!anchor) return;

    bar.dataset.stickyReady = '1';

    function show(on) {
      if (bar.dataset.visible === String(on)) return;
      bar.dataset.visible = String(on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }

    /* Above the viewport, not merely outside it. On a phone the buy box is far
       below the fold on load, so "outside the viewport" is true before the
       customer has scrolled at all — the bar would slide up over the gallery the
       moment the page painted, which reads as a glitch rather than an offer. It
       earns its place only once the real button has gone past.

       Measured on scroll rather than with an IntersectionObserver. An observer
       only reports CHANGES in intersection, and going past the buy box in one
       move — a tapped anchor, a flung scroll, a restored position — never
       intersects, so no callback fires and the bar stays down for the rest of
       the page. Reproduced exactly that way. One rect read per frame is cheap,
       and rAF means a fling costs one read per paint, not one per scroll event. */
    var ticking = false;

    /* Both footers in the 28 footer group are in the DOM — the 28 one and the
       legacy one — with the template gate hiding whichever does not apply. A
       hidden section still has a box, so height is what separates them. */
    var footers = [].slice.call(document.querySelectorAll('.ft28, footer'));

    function footerInView() {
      for (var i = 0; i < footers.length; i++) {
        var r = footers[i].getBoundingClientRect();
        if (r.height > 0 && r.top < (window.innerHeight || 0)) return true;
      }
      return false;
    }

    function measure() {
      ticking = false;
      /* Down again over the footer: there is nothing to buy down there, and the
         bar otherwise covers the last row of links right where someone is
         reaching for them. Measured in the same rAF pass as the show test so
         the two can never disagree about a single frame. */
      show(anchor.getBoundingClientRect().bottom < 0 && !footerInView());
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    measure();

    /* Anything that covers the page covers this too. The bar is fixed, so
       without this it floats over the open cart drawer and over the upsell
       popup — and its button would still be tappable through them. Driven off
       the same two states the rest of this file already tracks. */
    function syncSuppressed() {
      var drawer = document.getElementById('mini-cart') || document.querySelector('cart-drawer, cart-drawer-v2');
      var covered =
        !!(drawer && (drawer.hasAttribute('open') || drawer.classList.contains('is-open'))) ||
        !!document.querySelector('[data-pdp-upsell][data-open="true"]');
      bar.dataset.suppressed = covered ? 'true' : 'false';
    }

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (records) {
        var relevant = records.some(function (record) {
          return record.target.matches('#mini-cart, cart-drawer, cart-drawer-v2, [data-pdp-upsell]');
        });
        if (relevant) syncSuppressed();
      }).observe(document.body, {
        attributes: true,
        attributeFilter: ['open', 'class', 'data-open'],
        subtree: true
      });
    }
    document.documentElement.addEventListener('cart:refresh', syncSuppressed);
    syncSuppressed();

    /* The name follows the chosen scent. renderVariant writes the buy box's
       copy of it and knows nothing about this bar, so mirror that element
       rather than duplicating the rules about when it may be rewritten. */
    var source = document.querySelector('[data-buy-product-name]');
    var target = bar.querySelector('[data-sticky-atc-name]');
    if (source && target) {
      /* Seed before observing. Liquid renders both from the same static setting,
         so on a page that opens on a scent other than the first - the perfumes
         open on Seduction - the buy box is corrected by renderVariant during
         init(), which initAll runs BEFORE initStickyAtc. The observer therefore
         attaches after the only change it was waiting for, and the bar kept the
         name Liquid gave it while the buy box above showed the right one.
       */
      target.textContent = source.textContent;
      if (typeof MutationObserver === 'function') {
        new MutationObserver(function () {
          target.textContent = source.textContent;
        }).observe(source, { childList: true, characterData: true, subtree: true });
      }
    }

    /* The thumbnail follows the chosen scent using its product's First Custom
       Product Image. Liquid resolves the metafield and fallbacks for both the
       PDP variants and the separate scent products, keyed by the same variant
       IDs as the picker. Do not copy the picker's image over a mapped thumbnail.

       The id comes from whichever scent option is currently marked selected —
       markSelected above keeps that attribute in step with the chosen variant.
       NOT from [data-variant-input]: nothing in this theme's Liquid emits that
       selector, so it resolves to null. renderVariant guards it with `if
       (input)` and silently does nothing, which is why the dangling hook went
       unnoticed; reading `.value` off it here left every lookup undefined and
       the thumbnail stuck on whichever scent rendered first.

       The picker's src changing is still the signal that a variant changed —
       renderVariant sets it with setAttribute, which an observer sees. */
    var thumbEl = bar.querySelector('[data-sticky-atc-thumb]');
    var thumbData = bar.querySelector('[data-sticky-atc-images]');
    var scentImg = document.querySelector('[data-scent-image]');

    if (thumbEl && thumbData && scentImg && typeof MutationObserver === 'function') {
      var thumbMap = null;
      try {
        thumbMap = JSON.parse(thumbData.textContent);
      } catch (e) {
        thumbMap = null;
      }

      var selectedVariantId = function () {
        var picked = document.querySelector('[data-scent-option][aria-selected="true"]');
        return picked ? picked.getAttribute('data-variant-id') : null;
      };

      var applyThumb = function () {
        var id = selectedVariantId();
        var next = id && thumbMap[id];

        /* A picker override can still supply an image when the product has no
           metafield, gallery image or variant image to put in the map. */
        if (!next && scentImg) next = scentImg.getAttribute('src');

        if (next && next !== thumbEl.getAttribute('src')) thumbEl.setAttribute('src', next);
      };

      if (thumbMap) {
        /* Seeded for the same reason as the name above. */
        applyThumb();
        new MutationObserver(applyThumb).observe(scentImg, { attributes: true, attributeFilter: ['src'] });
      }
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-pdp-buybox-root]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();


document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-pdp-freescent]');
  if (!container) return;

  const options = container.querySelectorAll('[data-freescent-option]');
  
  // Find pre-selected option via markup attribute, or fallback to the 2nd item (index 1)
  let selectedOption = container.querySelector('[aria-selected="true"]');
  if (!selectedOption && options.length > 1) {
    selectedOption = options[1]; // Index 1 is the 2nd item
  } else if (!selectedOption && options.length > 0) {
    selectedOption = options[0];
  }

  if (selectedOption) {
    // Sync attributes
    options.forEach(opt => opt.setAttribute('aria-selected', 'false'));
    selectedOption.setAttribute('aria-selected', 'true');

    // Sync button UI header text & image
    const nameEl = container.querySelector('[data-freescent-name]');
    const imgEl = container.querySelector('[data-freescent-image]');
    const optImg = selectedOption.querySelector('img');
    const optText = selectedOption.querySelector('span');

    if (nameEl && optText) nameEl.textContent = optText.textContent;
    if (imgEl && optImg) imgEl.src = optImg.src;

    // Save selected variant ID to hidden input or dataset
    const variantId = selectedOption.dataset.variantId;
    container.dataset.selectedVariantId = variantId;
  }
});



